module.exports = __webpack_public_path__ + "img/Twitter_logo@2x.ccc60518.png";